import React, { useMemo } from 'react';
import { View, Text, useWindowDimensions } from 'react-native';
import CustomPressable from '../../customPressable/customPressable';
import { ImageComp } from '../../Image/Image';
import { useCssStyle } from '../../../customHook/getCssStyle';
import { getCleanUrl } from '../../../utils/Helper';
import RenderHTML from 'react-native-render-html';

const InfoWidget_Potrait = (props) => {
  const { listItemData = [], handleOnWidgetClick } = props || {};
  const getStyles = useCssStyle();
  const { width } = useWindowDimensions()


  if (!listItemData.length) {
    return null;
  }

  return (
    <>
      {
        listItemData.map(widgetData => {
          let widgetImg = widgetData.btnImageUrl ? getCleanUrl(widgetData.btnImageUrl) : null;
          const customWidgetTitleStyle = getStyles([
            'infoWidgetHeaderTitle',
            `infoWidgetHeaderTitle_${widgetData.widgetMetaHtmlId}`,
            `infoWidgetHeaderTitle_${widgetData.id}`,
          ]);


          const customWidgetSubTitleStyle = getStyles([
            'infoWidgetHeaderSubtitle',
            `infoWidgetHeaderSubtitle_${widgetData.widgetMetaHtmlId}`,
            `infoWidgetHeaderSubtitle_${widgetData.id}`
          ]);

          return (
            <CustomPressable 
              onPress={() => handleOnWidgetClick(widgetData)} 
              key={widgetData.id} 
              style={getStyles( ['infoWidgetsWidgetContainer', `infoWidgetsWidgetContainer_${widgetData.widgetMetaHtmlId}`, `infoWidgetsWidgetContainer_${widgetData.id}`])} 
              id={`infoWidgetsWidgetContainer infoWidgetsWidgetContainer_${widgetData.widgetMetaHtmlId} infoWidgetsWidgetContainer_${widgetData.id}`} 
            >
              {widgetImg && (
                <ImageComp
                  source={widgetImg}
                  style={getStyles(['infoWidgetImageStyle', `infoWidgetImageStyle_${widgetData.widgetMetaHtmlId}`, `infoWidgetImageStyle_${widgetData.id}`])}
                  id={`infoWidgetImageStyle infoWidgetImageStyle_${widgetData.widgetMetaHtmlId} infoWidgetImageStyle_${widgetData.id}`}
                />
              )}
              {widgetData.widgetTitle && (
                <RenderHTML
                  contentWidth={width}
                  baseStyle={customWidgetTitleStyle}
                  source={{ html: widgetData.widgetTitle }}
                  systemFonts={Array.isArray(customWidgetTitleStyle?.fontFamily) ? customWidgetTitleStyle?.fontFamily : [customWidgetTitleStyle.fontFamily]}
                  id={`infoWidgetHeaderTitle infoWidgetHeaderTitle_${widgetData.widgetMetaHtmlId} infoWidgetHeaderTitle_${widgetData.id}`}
                />
              )}
              {widgetData.widgetDesc && (
                <View style={customWidgetSubTitleStyle}>
                  <RenderHTML
                    contentWidth={width}
                    baseStyle={customWidgetSubTitleStyle}
                    source={{ html: widgetData.widgetDesc }}
                    systemFonts={[customWidgetSubTitleStyle.fontFamily]}
                    id={`infoWidgetHeaderSubtitle infoWidgetHeaderSubtitle_${widgetData.widgetMetaHtmlId}`}
                    
                  />
                </View>
              )}
              {widgetData.buttonTitle &&
                <View 
                  style={getStyles(['infoWidgetButtonContainer', `infoWidgetButtonContainer_${widgetData.widgetMetaHtmlId}`, `infoWidgetButtonContainer_${widgetData.id}`])}
                  id={`infoWidgetButtonContainer infoWidgetButtonContainer_${widgetData.widgetMetaHtmlId} infoWidgetButtonContainer_${widgetData.id}`}
                >
                  <Text 
                    style={getStyles(['infoWidgetButtonContainerText', `infoWidgetButtonContainerText_${widgetData.widgetMetaHtmlId}`, `infoWidgetButtonContainerText_${widgetData.id}`])}
                    id={`infoWidgetButtonContainerText infoWidgetButtonContainerText_${widgetData.widgetMetaHtmlId} infoWidgetButtonContainerText_${widgetData.id}`}
                  >{widgetData.buttonTitle}</Text>
                </View>
              }
            </CustomPressable>
          )
        })
      }
    </>
  );
};

export default React.memo(InfoWidget_Potrait);